import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

type Currency = 'USD' | 'CLP' | 'BRL';

interface CurrencySelectorProps {
  value?: Currency;
  onChange?: (value: Currency) => void;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const currencies = [
    { value: 'USD', label: 'USD - US Dollar' },
    { value: 'CLP', label: 'CLP - Chilean Peso' },
    { value: 'BRL', label: 'BRL - Brazilian Real' },
  ];

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={t('common:selectCurrency', 'Select Currency')}
      options={currencies}
      style={{ width: 120 }}
    />
  );
};

export default CurrencySelector; 